/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */

// tslint:disable:max-line-length
export enum RGSErrorCode
{
    // Bad requests.
    INVALID_REQUEST, // invalid requests – client sent in bad input so the client needs to figure out why it’s sending bad input.  The server log has more details.
    GAME_NOT_STARTED, // the game round or playId is for a play that has not occurred.  Client needs to call requestSetup. (This can only happen in resultDisplayed)
    RETRY_REQUEST_PLAY, // RGS's server has saved out protocol transaction data but not yet completed the transaction.  The game needs to retry requestPlay or perform requestSetup.
    AUTHENTICATION,  // invalid authentication, client needs to log out of the game.
    AUTHORIZATION,  // not authorized to perform the request

    // Player related errors.
    INSUFFICIENT_FUND,  // balance too low for wager. Client needs to spin to a loser reel stop and let the player know that the spin did not count.  Slot will return a temporary loser stop game-state.
    PLAY_LIMIT_REACHED,  // player's wager limit has been reached. Client needs to spin to a loser reel stop and let the player know that the spin did not count.  Slot will return a temporary loser stop game-state.

    // Connection error
    CONNECTION_ERROR,  // timeout, server went offline etc.  Whatever the client does it needs to retry.

    // Update Configuration
    UPDATE_CONFIG,  // the game configuration has been changed so the client needs to request setup again to get the new config.

    // Services error.
    PRIZEGEN_ERROR,  // bad prize generation happened and the client needs to call request setup.
    BAD_PLAYER_STATE,  // prize gen server has crashed and is in the process of recovering.

    RGS_ERROR,  // general server error.
    WALLET_ERROR,  // general platform's wallet error.
    WALLET_ACCESS_TOKEN_EXPIRED,  // client needs to log out an log back in again.
    WALLET_NO_WAGER_DATA, // wager not found
    WALLET_REALITY_CHECK_EXTENSION, // jurisdictional requirement on play limits
    WALLET_GEOLOCATION_FAILURE, // player is not inside approved gambling zone
    WALLET_WAGER_ROLLBACK_PENDING,
    WALLET_WAGER_ROLLBACK_COMPLETED,

    UNDEFINED_ERROR,  // don't know what happened.  Most likely error with error translation between wallet platform and RGS.
    REQUESTED_PLAY_ALREADY_EXIST
}
